export enum PriorityLevel {
  HIGH = 'High',
  MEDIUM = 'Medium',
  LOW = 'Low',
}

export enum UrgencyLevel {
  TODAY = 'Today',
  TWO_DAYS = '2 days',
  NON_URGENT = 'Non urgent',
}

export enum ComplexityLevel {
  SIMPLE = 'Simple',
  MEDIUM = 'Medium',
  COMPLEX = 'Complex',
}
